import { render, staticRenderFns } from "./Mini_Question.vue?vue&type=template&id=14ca7ce5&scoped=true&"
import script from "./Mini_Question.vue?vue&type=script&lang=js&"
export * from "./Mini_Question.vue?vue&type=script&lang=js&"
import style0 from "./Mini_Question.vue?vue&type=style&index=0&id=14ca7ce5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca7ce5",
  null
  
)

export default component.exports